import React from "react";
import { connect } from "react-redux";
import { Button } from "@vds/buttons";
import { TileContainer } from "@vds/tiles";
import { Title } from "@vds/typography";

function EmberTVConnection(props) {
  const {
    dispatch,
    product,
    clickFn,
    buildProduct,
    isChecked,
    ecProfileCart,
    isBlocked,
    flowType,
  } = props;
  const isClassicFlow = !buildProduct?.mnFromApi;

  const TVConnection = product => {
    //aria-label logic for tv count tiles
    const tvConnectionAriaLabel = () => {
      const unit = product?.unitCount ?? ""
      const priceTextSingle = "1 Tv connection included"
      const newPrice = product?.displayPrice?.split(".")?.[0] ?? ""
      const priceTextMultiple = unit + "Tv connections" + newPrice + "per month"
      return {
        mainblock: (unit == "1" ? priceTextSingle : priceTextMultiple),
        mainblockSelect: (unit == "1" ? "1 Tv connection select" : `${unit} Tv connections select`)
      }
    }
    const tilePriceText = product?.displayPrice ? `${product.displayPrice?.split(".")?.[0]}/mo` : "";
    return (
      <>
        <div className={flowType == "EC" ? 'ecTvConnections' : ''}>
          <TileContainer
            ariaLabel={tvConnectionAriaLabel().mainblock}
            padding='12px'
            aspectRatio='3:4'
            width='174px'
            height='228px'
            onClick={(e) => {
              e.stopPropagation();
            }}
            backgroundColor="white"
            showBorder={true}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <TileContainer aspectRatio='3:4' width='142px' height='96px' backgroundColor={""} padding='20px 55px'>
                <Title primitive="p" color='black' size="XLarge">{product?.unitCount}</Title>
              </TileContainer>
              <Title color='black' size='small' primitive="p">
                <p style={{ 'text-align': 'center', 'font-size': '1.25rem', 'margin-bottom': '1rem' }}>
                  {isClassicFlow
                    ? (tilePriceText)
                    : (product?.unitCount == "1"
                      ? "Included"
                      : tilePriceText)
                  }
                </p>
              </Title>
              {ecProfileCart?.ProfileVRoomProduct?.prodId == product?.id && buildProduct?.vRoom?.selectedProduct == null
                ? (flowType == 'EC')
                  ? <div className="vroomBtnStyling"><p className='vroom-selected-btn'>Selected</p></div>
                  : <p className='vroom-selected-btn'>Selected</p>
                : isChecked
                  ? ((flowType == 'EC')
                    ? <div className="vroomBtnStyling"><p className='vroom-selected-btn'>Selected</p></div>
                    : <p className='vroom-selected-btn'>Selected</p>
                  )
                  : (
                    <Button
                      tabIndex="0"
                      id="select-btn-tv"
                      ariaLabel={tvConnectionAriaLabel().mainblockSelect}
                      size="large"
                      surface="light"
                      disabled={isBlocked ? true : false}
                      use="primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        clickFn();
                      }}
                    >
                      Select
                    </Button>
                  )
              }
            </div>
          </TileContainer>
        </div>
      </>
    );
  }

  return (
    <TVConnection {...product} />
  );
}

const mapStateToProps = state => {
  return {
    buildProduct: state.buildProduct,
    flowType: state.app.flowType,
    ecProfileCart: state.ecProfileCart,
  }
}

export default connect(mapStateToProps)(EmberTVConnection);
